import React from "react";
import {
  AccountManagerLayout,
  CogsFilledIcon,
  useAuth,
} from "djinn-components";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../../utils/initSupabase";

interface AdminAccountLayoutProps {
  title?: string;
  children: any;
}

const AdminAccountLayout: React.FC<AdminAccountLayoutProps> = ({
  children,
  title = "Admin Area",
}) => {
  const navigate = useNavigate();

  const { user } = useAuth();

  return (
    <AccountManagerLayout
      logo="/logo-full.svg"
      Link={({ className = "", to, children }: any) => (
        <Link to={to}>
          <div className={className}>{children}</div>
        </Link>
      )}
      user={{
        avatar: null,
        name: user?.email ?? "",
      }}
      routes={{
        chooseProject: "/",
      }}
      logoutClick={async () => {
        await supabase.auth.signOut();
        navigate("/");
      }}
      dropdownTeams={
        <>
          <div
            className="px-4 pb-3 pt-3 text-xs flex items-center justify-between"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <p className="text-gray-400">{user?.email}</p>
            <Link to="/account">
              <div className="text-gray-400 hover:text-white cursor-pointer">
                <CogsFilledIcon size={16} />
              </div>
            </Link>
          </div>
        </>
      }
    >
      <title>{title} | Appsicle</title>
      <link rel="icon" href="/icon.png" />
      {children}
    </AccountManagerLayout>
  );
};

export default AdminAccountLayout;
